import {WhitespaceValidator} from '@spa/validators';

import {AmountControl, BaseControl, CheckboxControl, SelectControl} from 'appShared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {Validators} from '@angular/forms';
import {FeedPriceTypesEnum, MarketDataFeedAndBundleModel, MarketDataFeedInterface, SesHelper} from '@spa/api';

type AddFeedAndBundleType = string | number | boolean | object;

export const AddNewFeedBundleDescriptionSelector = 'addNewFeedBundleDescription';
export const AddNewFeedBundleNameSelector = 'addNewFeedBundleName';
export const AddNewFeedBundleCostToAlaricProSelector = 'addNewFeedBundleCostToAlaricPro';
export const AddNewFeedBundleCostToAlaricNonProSelector = 'addNewFeedBundleCostToAlaricNonPro';
export const AddNewFeedBundleIndividualPriceProSelector = 'addNewFeedBundleIndividualPricePro';
export const AddNewFeedBundleIndividualPriceNonProSelector = 'addNewFeedBundleIndividualPriceNonPro';
export const AddNewFeedBundleAlaricInternalPriceSelector = 'addNewFeedBundleAlaricInternalPrice';
export const AddNewFeedBundlePlatformFrontendIdSelector = 'addNewFeedBundlePlatformFrontendIds';
export const AddNewFeedBundleCurrencySelector = 'addNewFeedBundleCurrency';
export const FEEDID_CHECKBOX_PREFIX = 'feed_';

export const AddNewFeedBundleDialogConfig = (isUpdate = false): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                hidden: true,
                customText: isUpdate ? 'Add Feed' : 'Create Bundle'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };

};

export const AddNewFeedBundleControls = (): BaseControl<AddFeedAndBundleType>[] => {
    return [
        new BaseControl({
            name: AddNewFeedBundleNameSelector,
            value: '',
            placeholder: 'Bundle Name',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedBundleDescriptionSelector,
            value: '',
            placeholder: 'Bundle Description',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: AddNewFeedBundlePlatformFrontendIdSelector,
            value: null,
            placeholder: 'Platform Frontend',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
        new AmountControl({
            name: AddNewFeedBundleCostToAlaricProSelector,
            value: null,
            placeholder: 'Cost to Alaric (pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedBundleCostToAlaricNonProSelector,
            value: null,
            placeholder: 'Cost to Alaric (non-pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedBundleIndividualPriceProSelector,
            value: null,
            placeholder: 'Individual Price (pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedBundleIndividualPriceNonProSelector,
            value: null,
            placeholder: 'Individual Price (non-pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedBundleAlaricInternalPriceSelector,
            value: null,
            placeholder: 'Internal Price',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new SelectControl({
            name: AddNewFeedBundleCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
    ];
};

export const AddNewFeedToExistingBundleControls = (): BaseControl<AddFeedAndBundleType>[] => {
    return [];
};

const prepareFeedAndBundlePlaceHolder = (feed: MarketDataFeedAndBundleModel): string => {
    return `${feed.name}-${feed.defaultForProTxt}-${feed.defaultForNonProTxt}-${feed.defaultCurrency}`;
};

const preparePlaceHolder = (feed: MarketDataFeedInterface): string => {
    const defaultProDisplayPrice = SesHelper.getPriceDataBy(feed.priceList, FeedPriceTypesEnum.SelfPro,false).displayPrice;
    const defaultNonProDisplayPrice = SesHelper.getPriceDataBy(feed.priceList, FeedPriceTypesEnum.SelfNonPro,false).displayPrice;
    const currency = SesHelper.getPriceCurrency(feed.priceList);
    return `${feed.name}-${defaultProDisplayPrice}-${defaultNonProDisplayPrice}-${currency}`;
};

export const prepareFeedCheckbox = (feed: MarketDataFeedInterface | MarketDataFeedAndBundleModel): CheckboxControl => {
    let placeholder = null;

    if (feed instanceof MarketDataFeedAndBundleModel) {
        placeholder = prepareFeedAndBundlePlaceHolder(feed);
    } else {
        placeholder = preparePlaceHolder(feed);
    }

    return new CheckboxControl({
        name: `${FEEDID_CHECKBOX_PREFIX}${feed.id}`,
        value: feed.id,
        placeholder,
        validators: [],
        componentType: ComponentTypesEnum.Checkbox,
        floatingLabelNever: true,
        checked: false,
        color: ColorCodesEnum.Primary,
        expectBooleanValue: false
    });
};

